// extracted by mini-css-extract-plugin
module.exports = {"comments":"T_dF","comments__list":"T_dG"};